import { Container } from "reactstrap";
import { Link } from "react-router-dom";
import SimpleBar from "simplebar-react";
import React, { useEffect } from "react";
import VerticalLayout from "./VerticalLayouts";
import DarulLogo from "../assets/images/darulLogo.png";

const Sidebar = ({ layoutType }) => {
  useEffect(() => {
    var verticalOverlay = document.getElementsByClassName("vertical-overlay");
    if (verticalOverlay) {
      verticalOverlay[0].addEventListener("click", function () {
        document.body.classList.remove("vertical-sidebar-enable");
      });
    }
  });

  return (
    <React.Fragment>
      <div
        className="app-menu navbar-menu"
        style={{
          transition: ".5s all",
        }}
      >
        <React.Fragment>
          <SimpleBar id="scrollbar" className="h-100">
            <div className="flex flex-column justify-center items-center">
              <img
                src={DarulLogo}
                alt=""
                style={{
                  objectFit: "contain",
                  width: "80%",
                  objectPosition: "center",
                  padding: "5% 10%",
                }}
              />
              {/* <h2 className="text-primary font-bold ">Online</h2> */}
            </div>
            <Container fluid>
              <div id="two-column-menu"></div>
              <ul className="navbar-nav" id="navbar-nav">
                <VerticalLayout layoutType={layoutType} />
              </ul>
            </Container>
          </SimpleBar>
          <div className="sidebar-background"></div>
        </React.Fragment>
      </div>
      <div className="vertical-overlay"></div>
    </React.Fragment>
  );
};

export default Sidebar;
